"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAN_VARIABLE_KEY = exports.MetadataFields = exports.FilterOptsCommissionPlan = void 0;
__exportStar(require("./what.if"), exports);
var FilterOptsCommissionPlan;
(function (FilterOptsCommissionPlan) {
    FilterOptsCommissionPlan["IS_ARCHIVED"] = "is_archived";
    FilterOptsCommissionPlan["IS_NOT_ARCHIVED"] = "is_not_archived";
    FilterOptsCommissionPlan["ALL_PLANS"] = "all_plans";
})(FilterOptsCommissionPlan = exports.FilterOptsCommissionPlan || (exports.FilterOptsCommissionPlan = {}));
var MetadataFields;
(function (MetadataFields) {
    MetadataFields["START_DATE"] = "start_date";
    MetadataFields["END_DATE"] = "end_date";
    MetadataFields["PAYOUT_DATE"] = "payout_date";
})(MetadataFields = exports.MetadataFields || (exports.MetadataFields = {}));
exports.PLAN_VARIABLE_KEY = 'plan';
